import { Pipe, PipeTransform } from '@angular/core'
import { bigNumberToView } from '@adex/shared/utils/view'


@Pipe({
  name: 'numberFormatter'
})
export class NumberFormatterPipe implements PipeTransform {

  public transform(value: string | number): string {
    return bigNumberToView(value)
  }

}
